import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import GrayStack from 'svg/gray-stack.svg';
import BlueStack from 'svg/blue-stack.svg';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import StackTooltip from './StackTooltip';
import styles from './Stack.pcss';
const Stack = ({ data, tooltipType })=>{
    useStyles(styles);
    const activeReading = useSelector(selectors.selectedReading);
    const setActiveReading = useAction(actions.setSelectedReading);
    const [isOpen, setIsOpen] = useState(false);
    const counterClassNames = cn(styles.stack__counter, {
        [styles['stack__counter--white']]: isOpen
    });
    const renderMarker = ()=>{
        if (tooltipType === 'measurement') {
            return isOpen ? /*#__PURE__*/ _jsx(BlueStack, {}) : /*#__PURE__*/ _jsx(GrayStack, {});
        }
        // eslint-disable-next-line max-len
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.stack__circle, styles[`${isOpen ? 'stack__circle--blue' : 'stack__circle--gray'}`])
        });
    };
    const onStackClickHandler = ()=>{
        setActiveReading(data[0]);
        setIsOpen(true);
    };
    const onTooltipCloseHandler = ()=>{
        setIsOpen(false);
    };
    useEffect(()=>{
        if (activeReading && activeReading.type === 'normal') {
            setActiveReading(activeReading);
        }
    }, []);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ _jsxs("div", {
        className: styles.stack,
        onClick: onStackClickHandler,
        children: [
            renderMarker(),
            /*#__PURE__*/ _jsx("span", {
                className: counterClassNames,
                children: data.length
            }),
            isOpen && /*#__PURE__*/ _jsx(StackTooltip, {
                onTooltipClose: onTooltipCloseHandler,
                data: data,
                tooltipType: tooltipType
            })
        ]
    }));
};
export default Stack;
